import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import Solutions from "../components/Solutions/AdditionalSolutions.jsx";
import AmbulatoryClinics from "../pages/AmbulatoryClinics/AmbulatoryClinics";
import Clinicians from "../pages/Individual_Provider/Clinicians.jsx";
import BusinessFinance from "../pages/Practice_Administrators/BusinessFinance.jsx";
import Hospitals from "../pages/Hospitals/Hospitals.jsx";
import AboutUs from "../pages/aboutus/AboutUs.jsx";
import ContactUs from "../pages/Contactus/ContactUs.jsx";
import Genomic from "../pages/Genomic/Genomic.jsx";
import AiSolutions from "../pages/Ai_solutions/Ai_solutions.jsx";
import OurProducts from "../pages/our_products/our_products.jsx";
import PageViz from "../components/page/page_viz.jsx";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/solutions" element={<Solutions />} />
            <Route path="/ambulatoryClinics" element={<AmbulatoryClinics />} />
            <Route path="/clinicians" element={<Clinicians />} />
            <Route path="/businessFinance" element={<BusinessFinance />} />
            <Route path="/hospitals" element={<Hospitals />} />
            <Route path="/aboutUS" element={<AboutUs />} />
            <Route path="/contactUS" element={<ContactUs />} />
            <Route path="/genomicLaboratories" element={<Genomic />} />
            <Route path="/AI-Solutions" element={<AiSolutions />} />
            <Route path="/our-products" element={<OurProducts />} />
            <Route path="/visualization" element={<PageViz />} />


            {/* Optional 404 */}
            <Route path="*" element={<h2>Page Not Found</h2>} />
        </Routes>
    );
};

export default AppRoutes;
